import * as React from 'react';
import i18next from 'i18next';
import styled from 'styled-components';

interface FormErrorProps {
  name?: string;
  data?: {
    [key: string]: string;
  };
}

class FormError extends React.Component<FormErrorProps> {

  render() {
    return (
      <div>
        {
          this.props.data ? (Object.keys(this.props.data).map((key: string) => {
            return <ErrorMessage key={key}>{this.props.data ? <div className={`${this.props.name}-form-err-msg`}>{i18next.t(this.props.data[key])}</div> : undefined}</ErrorMessage>;
          })) : undefined
        }
      </div>
    );
  }

}

const ErrorMessage = styled.div`
  color: red;
  text-align: center;
  font-size: 0.875em;
`;

export default FormError;